export const WarningIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15C12.5523 15 13 14.5523 13 14V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14C11 14.5523 11.4477 15 12 15Z"
        fill="#828E9F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6736 17.5049L12.8686 5.56391C12.485 4.89074 11.5146 4.89075 11.131 5.56391L4.32603 17.5049C3.94612 18.1715 4.42755 19 5.19485 19H18.8048C19.5721 19 20.0535 18.1715 19.6736 17.5049ZM14.6063 4.57365C13.4554 2.55416 10.5442 2.55416 9.39335 4.57365L2.58839 16.5146C1.44865 18.5146 2.89293 21 5.19485 21H18.8048C21.1067 21 22.551 18.5146 21.4113 16.5146L14.6063 4.57365Z"
        fill="#828E9F"
      />
      <path
        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
        fill="#828E9F"
      />
    </svg>
  );
};

export const WarningIllustratorSmall = () => {
  return (
    <svg
      width="142"
      height="171"
      viewBox="0 0 142 171"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_934_17"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="142"
        height="171"
      >
        <path d="M142 0H0V170.036H142V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_934_17)">
        <path
          d="M138.223 61.8618H55.977C53.8904 61.8618 52.1992 63.553 52.1992 65.6396V166.258C52.1992 168.345 53.8904 170.036 55.977 170.036H138.223C140.31 170.036 142.001 168.345 142.001 166.258V65.6396C142.001 63.553 140.31 61.8618 138.223 61.8618Z"
          fill="#2E435F"
        />
        <path
          d="M104.111 4.78784V140.91C104.111 142.676 102.672 144.108 100.906 144.108H4.78907C3.03137 144.108 1.5918 142.676 1.5918 140.91V4.78784C1.5918 3.02219 3.03137 1.59058 4.78907 1.59058H100.906C102.672 1.59058 104.111 3.02219 104.111 4.78784Z"
          fill="#2E435F"
        />
        <path
          d="M101.724 3.19734V8.34316H0.794922V3.19734C0.794922 1.87708 1.87659 0.79541 3.19685 0.79541H99.3137C100.642 0.79541 101.724 1.87708 101.724 3.19734Z"
          fill="#00C2FF"
        />
        <path
          d="M101.724 9.13843V139.32C101.724 140.648 100.642 141.721 99.3137 141.721H3.19685C1.87659 141.721 0.794922 140.648 0.794922 139.32V9.13843H101.724Z"
          fill="white"
        />
        <path
          d="M99.3142 0H3.19727C1.43956 0 0 1.43161 0 3.19727V139.32C0 141.085 1.43956 142.517 3.19727 142.517H99.3142C101.08 142.517 102.52 141.085 102.52 139.32V3.19727C102.52 1.43161 101.08 0 99.3142 0ZM101.724 139.32C101.724 140.648 100.642 141.721 99.3142 141.721H3.19727C1.877 141.721 0.795338 140.648 0.795338 139.32V9.13844H101.724V139.32ZM101.724 8.34314H0.795338V3.19727C0.795338 1.877 1.877 0.795338 3.19727 0.795338H99.3142C100.642 0.795338 101.724 1.877 101.724 3.19727V8.34314Z"
          fill="#2E435F"
        />
        <path
          d="M139.614 64.0489V68.8685H51.4023V64.0489C51.4023 62.4026 52.7385 61.0664 54.3848 61.0664H136.631C138.278 61.0664 139.614 62.4026 139.614 64.0489Z"
          fill="#00C2FF"
        />
        <path
          d="M139.614 69.6638V164.667C139.614 166.314 138.278 167.65 136.631 167.65H54.3848C52.7385 167.65 51.4023 166.314 51.4023 164.667V69.6638H139.614Z"
          fill="white"
        />
        <path
          d="M136.631 60.271H54.3852C52.3016 60.271 50.6074 61.9646 50.6074 64.0488V164.667C50.6074 166.751 52.3016 168.445 54.3852 168.445H136.631C138.715 168.445 140.409 166.751 140.409 164.667V64.0488C140.409 61.9646 138.715 60.271 136.631 60.271ZM139.614 164.667C139.614 166.313 138.278 167.65 136.631 167.65H54.3852C52.7389 167.65 51.4027 166.313 51.4027 164.667V69.6637H139.614V164.667ZM139.614 68.8684H51.4027V64.0488C51.4027 62.4025 52.7389 61.0663 54.3852 61.0663H136.631C138.278 61.0663 139.614 62.4025 139.614 64.0488V68.8684Z"
          fill="#2E435F"
        />
        <path
          d="M43.7755 44.9367C40.4908 50.2971 34.5734 53.8762 27.8449 53.8762C21.1163 53.8762 15.191 50.2971 11.9062 44.9367C14.0776 42.9325 19.5097 38.8206 27.4393 38.6854C35.7824 38.5422 41.4849 42.8371 43.7755 44.9367Z"
          fill="#00C2FF"
        />
        <path
          d="M27.8454 15.6921C17.1003 15.6921 8.35156 24.4409 8.35156 35.1859C8.35156 45.931 17.1003 54.6716 27.8454 54.6716C38.5904 54.6716 47.3312 45.931 47.3312 35.1859C47.3312 24.4409 38.5904 15.6921 27.8454 15.6921ZM27.8454 53.8763C21.1088 53.8763 15.1915 50.2972 11.9067 44.9368C14.078 42.9326 19.5102 38.8206 27.4397 38.6854C35.7829 38.5423 41.4854 42.8371 43.776 44.9368C40.4912 50.2972 34.5739 53.8763 27.8454 53.8763ZM27.4238 37.8901C19.3829 38.0253 13.8235 42.1292 11.4932 44.2369C9.99792 41.5487 9.14691 38.4627 9.14691 35.1859C9.14691 24.8784 17.5377 16.4875 27.8454 16.4875C38.153 16.4875 46.5359 24.8784 46.5359 35.1859C46.5359 38.4627 45.6848 41.5487 44.1896 44.2369C41.7479 42.0259 35.8703 37.7231 27.4238 37.8901Z"
          fill="#2E435F"
        />
        <path
          d="M27.8439 33.7703C31.3799 33.7703 34.2464 30.9038 34.2464 27.3678C34.2464 23.8318 31.3799 20.9653 27.8439 20.9653C24.3079 20.9653 21.4414 23.8318 21.4414 27.3678C21.4414 30.9038 24.3079 33.7703 27.8439 33.7703Z"
          fill="#2E435F"
        />
        <path
          d="M90.2711 47.8079H59.1894C58.2186 47.8079 57.4316 48.593 57.4316 49.5614C57.4316 50.5303 58.2186 51.3152 59.1894 51.3152H90.2711C91.2419 51.3152 92.0289 50.5303 92.0289 49.5614C92.0289 48.593 91.2419 47.8079 90.2711 47.8079Z"
          fill="#2E435F"
        />
        <path
          d="M90.2711 37.4685H59.1894C58.2186 37.4685 57.4316 38.2536 57.4316 39.2222C57.4316 40.1908 58.2186 40.976 59.1894 40.976H90.2711C91.2419 40.976 92.0289 40.1908 92.0289 39.2222C92.0289 38.2536 91.2419 37.4685 90.2711 37.4685Z"
          fill="#2E435F"
        />
        <path
          d="M90.2711 27.1289H59.1894C58.2186 27.1289 57.4316 27.914 57.4316 28.8826C57.4316 29.8512 58.2186 30.6364 59.1894 30.6364H90.2711C91.2419 30.6364 92.0289 29.8512 92.0289 28.8826C92.0289 27.914 91.2419 27.1289 90.2711 27.1289Z"
          fill="#2E435F"
        />
        <path
          d="M90.2711 16.7896H59.1894C58.2186 16.7896 57.4316 17.5747 57.4316 18.5433C57.4316 19.5118 58.2186 20.297 59.1894 20.297H90.2711C91.2419 20.297 92.0289 19.5118 92.0289 18.5433C92.0289 17.5747 91.2419 16.7896 90.2711 16.7896Z"
          fill="#2E435F"
        />
        <path
          d="M41.3729 68.0491H10.116C9.36052 68.0491 8.74805 68.6619 8.74805 69.4173V131.518C8.74805 132.273 9.36052 132.885 10.116 132.885H41.3729C42.1285 132.885 42.7409 132.273 42.7409 131.518V69.4173C42.7409 68.6619 42.1285 68.0491 41.3729 68.0491Z"
          fill="#00C2FF"
        />
        <path
          d="M132.456 76.1541H58.4656C57.8946 76.1541 57.4316 76.617 57.4316 77.188V116.462C57.4316 117.033 57.8946 117.496 58.4656 117.496H132.456C133.027 117.496 133.49 117.033 133.49 116.462V77.188C133.49 76.617 133.027 76.1541 132.456 76.1541Z"
          fill="#00C2FF"
        />
        <path
          d="M20.9969 6.05268C21.8139 6.05268 22.4762 5.39036 22.4762 4.57333C22.4762 3.75632 21.8139 3.09399 20.9969 3.09399C20.1799 3.09399 19.5176 3.75632 19.5176 4.57333C19.5176 5.39036 20.1799 6.05268 20.9969 6.05268Z"
          fill="#2E435F"
        />
        <path
          d="M13.0438 6.05268C13.8608 6.05268 14.5231 5.39036 14.5231 4.57333C14.5231 3.75632 13.8608 3.09399 13.0438 3.09399C12.2268 3.09399 11.5645 3.75632 11.5645 4.57333C11.5645 5.39036 12.2268 6.05268 13.0438 6.05268Z"
          fill="#2E435F"
        />
        <path
          d="M5.08872 6.05268C5.90571 6.05268 6.56803 5.39036 6.56803 4.57333C6.56803 3.75632 5.90571 3.09399 5.08872 3.09399C4.2717 3.09399 3.60938 3.75632 3.60938 4.57333C3.60938 5.39036 4.2717 6.05268 5.08872 6.05268Z"
          fill="#2E435F"
        />
        <path
          d="M71.8444 66.4505C72.6614 66.4505 73.3241 65.7883 73.3241 64.9714C73.3241 64.1544 72.6614 63.4917 71.8444 63.4917C71.0274 63.4917 70.3652 64.1544 70.3652 64.9714C70.3652 65.7883 71.0274 66.4505 71.8444 66.4505Z"
          fill="#2E435F"
        />
        <path
          d="M63.8893 66.4505C64.7063 66.4505 65.369 65.7883 65.369 64.9714C65.369 64.1544 64.7063 63.4917 63.8893 63.4917C63.0723 63.4917 62.4102 64.1544 62.4102 64.9714C62.4102 65.7883 63.0723 66.4505 63.8893 66.4505Z"
          fill="#2E435F"
        />
        <path
          d="M55.9367 66.4505C56.7537 66.4505 57.4159 65.7883 57.4159 64.9714C57.4159 64.1544 56.7537 63.4917 55.9367 63.4917C55.1197 63.4917 54.457 64.1544 54.457 64.9714C54.457 65.7883 55.1197 66.4505 55.9367 66.4505Z"
          fill="#2E435F"
        />
      </g>
    </svg>
  );
};

export const WarningIllustration = () => {
  return (
    <svg
      width="288"
      height="215"
      viewBox="0 0 288 215"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_934_16)">
        <mask
          id="mask0_934_16"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="288"
          height="345"
        >
          <path d="M288 0H0V344.861H288V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_934_16)">
          <path
            d="M280.338 125.466H113.529C109.297 125.466 105.867 128.896 105.867 133.128V337.199C105.867 341.431 109.297 344.861 113.529 344.861H280.338C284.57 344.861 288 341.431 288 337.199V133.128C288 128.896 284.57 125.466 280.338 125.466Z"
            fill="#2E435F"
          />
          <path
            d="M211.153 9.71066V285.79C211.153 289.371 208.233 292.275 204.652 292.275H9.71116C6.14625 292.275 3.22656 289.371 3.22656 285.79V9.71066C3.22656 6.12962 6.14625 3.22607 9.71116 3.22607H204.652C208.233 3.22607 211.153 6.12962 211.153 9.71066Z"
            fill="#2E435F"
          />
          <path
            d="M206.314 6.4848V16.9214H1.61328V6.4848C1.61328 3.80708 3.80708 1.61328 6.48479 1.61328H201.426C204.12 1.61328 206.314 3.80708 206.314 6.4848Z"
            fill="#00C2FF"
          />
          <path
            d="M206.314 18.5342V282.564C206.314 285.258 204.12 287.435 201.426 287.435H6.48479C3.80708 287.435 1.61328 285.258 1.61328 282.564V18.5342H206.314Z"
            fill="white"
          />
          <path
            d="M201.426 0H6.4846C2.91968 0 0 2.90355 0 6.4846V282.564C0 286.145 2.91968 289.049 6.4846 289.049H201.426C205.007 289.049 207.927 286.145 207.927 282.564V6.4846C207.927 2.90355 205.007 0 201.426 0ZM206.313 282.564C206.313 285.258 204.12 287.435 201.426 287.435H6.4846C3.80688 287.435 1.61308 285.258 1.61308 282.564V18.5343H206.313V282.564ZM206.313 16.9213H1.61308V6.4846C1.61308 3.80688 3.80688 1.61308 6.4846 1.61308H201.426C204.12 1.61308 206.313 3.80688 206.313 6.4846V16.9213Z"
            fill="#2E435F"
          />
          <path
            d="M283.162 129.902V139.677H104.254V129.902C104.254 126.563 106.964 123.853 110.303 123.853H277.112C280.452 123.853 283.162 126.563 283.162 129.902Z"
            fill="#00C2FF"
          />
          <path
            d="M283.162 141.29V333.973C283.162 337.312 280.452 340.022 277.112 340.022H110.303C106.964 340.022 104.254 337.312 104.254 333.973V141.29H283.162Z"
            fill="white"
          />
          <path
            d="M277.112 122.24H110.303C106.077 122.24 102.641 125.675 102.641 129.902V333.973C102.641 338.199 106.077 341.635 110.303 341.635H277.112C281.339 341.635 284.774 338.199 284.774 333.973V129.902C284.774 125.675 281.339 122.24 277.112 122.24ZM283.161 333.973C283.161 337.312 280.451 340.022 277.112 340.022H110.303C106.964 340.022 104.254 337.312 104.254 333.973V141.29H283.161V333.973ZM283.161 139.677H104.254V129.902C104.254 126.563 106.964 123.853 110.303 123.853H277.112C280.451 123.853 283.161 126.563 283.161 129.902V139.677Z"
            fill="#2E435F"
          />
          <path
            d="M88.7847 91.139C82.1227 102.011 70.1213 109.27 56.4746 109.27C42.8279 109.27 30.8105 102.011 24.1484 91.139C28.5522 87.0741 39.5695 78.7344 55.652 78.4602C72.5732 78.1698 84.139 86.8805 88.7847 91.139Z"
            fill="#00C2FF"
          />
          <path
            d="M56.4742 31.8262C34.6814 31.8262 16.9375 49.5702 16.9375 71.3629C16.9375 93.1557 34.6814 110.883 56.4742 110.883C78.2669 110.883 95.9947 93.1557 95.9947 71.3629C95.9947 49.5702 78.2669 31.8262 56.4742 31.8262ZM56.4742 109.27C42.8114 109.27 30.81 102.011 24.148 91.1393C28.5517 87.0744 39.5691 78.7347 55.6515 78.4605C72.5728 78.1701 84.1386 86.8808 88.7843 91.1393C82.1222 102.011 70.1209 109.27 56.4742 109.27ZM55.6193 76.8474C39.311 77.1216 28.0355 85.4451 23.3092 89.7198C20.2766 84.2676 18.5506 78.0088 18.5506 71.3629C18.5506 50.4574 35.5686 33.4393 56.4742 33.4393C77.3798 33.4393 94.3817 50.4574 94.3817 71.3629C94.3817 78.0088 92.6557 84.2676 89.6231 89.7198C84.6709 85.2355 72.7502 76.5087 55.6193 76.8474Z"
            fill="#2E435F"
          />
          <path
            d="M56.4736 68.4916C63.6452 68.4916 69.4589 62.6779 69.4589 55.5063C69.4589 48.3347 63.6452 42.521 56.4736 42.521C49.302 42.521 43.4883 48.3347 43.4883 55.5063C43.4883 62.6779 49.302 68.4916 56.4736 68.4916Z"
            fill="#2E435F"
          />
          <path
            d="M183.084 96.9624H120.045C118.076 96.9624 116.48 98.5548 116.48 100.519C116.48 102.484 118.076 104.076 120.045 104.076H183.084C185.053 104.076 186.649 102.484 186.649 100.519C186.649 98.5548 185.053 96.9624 183.084 96.9624Z"
            fill="#2E435F"
          />
          <path
            d="M183.084 75.9922H120.045C118.076 75.9922 116.48 77.5846 116.48 79.549C116.48 81.5134 118.076 83.1059 120.045 83.1059H183.084C185.053 83.1059 186.649 81.5134 186.649 79.549C186.649 77.5846 185.053 75.9922 183.084 75.9922Z"
            fill="#2E435F"
          />
          <path
            d="M183.084 55.0225H120.045C118.076 55.0225 116.48 56.6149 116.48 58.5793C116.48 60.5437 118.076 62.1362 120.045 62.1362H183.084C185.053 62.1362 186.649 60.5437 186.649 58.5793C186.649 56.6149 185.053 55.0225 183.084 55.0225Z"
            fill="#2E435F"
          />
          <path
            d="M183.084 34.0522H120.045C118.076 34.0522 116.48 35.6447 116.48 37.6091C116.48 39.5734 118.076 41.1659 120.045 41.1659H183.084C185.053 41.1659 186.649 39.5734 186.649 37.6091C186.649 35.6447 185.053 34.0522 183.084 34.0522Z"
            fill="#2E435F"
          />
          <path
            d="M83.9128 138.015H20.5186C18.9863 138.015 17.7441 139.258 17.7441 140.79V266.74C17.7441 268.272 18.9863 269.514 20.5186 269.514H83.9128C85.4452 269.514 86.6874 268.272 86.6874 266.74V140.79C86.6874 139.258 85.4452 138.015 83.9128 138.015Z"
            fill="#00C2FF"
          />
          <path
            d="M268.642 154.453H118.577C117.419 154.453 116.48 155.392 116.48 156.55V236.204C116.48 237.362 117.419 238.301 118.577 238.301H268.642C269.8 238.301 270.739 237.362 270.739 236.204V156.55C270.739 155.392 269.8 154.453 268.642 154.453Z"
            fill="#00C2FF"
          />
          <path
            d="M42.5862 12.2756C44.2432 12.2756 45.5865 10.9323 45.5865 9.27524C45.5865 7.6182 44.2432 6.2749 42.5862 6.2749C40.9292 6.2749 39.5859 7.6182 39.5859 9.27524C39.5859 10.9323 40.9292 12.2756 42.5862 12.2756Z"
            fill="#2E435F"
          />
          <path
            d="M26.4534 12.2756C28.1105 12.2756 29.4538 10.9323 29.4538 9.27524C29.4538 7.6182 28.1105 6.2749 26.4534 6.2749C24.7964 6.2749 23.4531 7.6182 23.4531 9.27524C23.4531 10.9323 24.7964 12.2756 26.4534 12.2756Z"
            fill="#2E435F"
          />
          <path
            d="M10.3226 12.2756C11.9796 12.2756 13.3229 10.9323 13.3229 9.27524C13.3229 7.6182 11.9796 6.2749 10.3226 6.2749C8.66557 6.2749 7.32227 7.6182 7.32227 9.27524C7.32227 10.9323 8.66557 12.2756 10.3226 12.2756Z"
            fill="#2E435F"
          />
          <path
            d="M145.711 134.773C147.368 134.773 148.712 133.43 148.712 131.773C148.712 130.116 147.368 128.772 145.711 128.772C144.054 128.772 142.711 130.116 142.711 131.773C142.711 133.43 144.054 134.773 145.711 134.773Z"
            fill="#2E435F"
          />
          <path
            d="M129.578 134.773C131.235 134.773 132.579 133.43 132.579 131.773C132.579 130.116 131.235 128.772 129.578 128.772C127.921 128.772 126.578 130.116 126.578 131.773C126.578 133.43 127.921 134.773 129.578 134.773Z"
            fill="#2E435F"
          />
          <path
            d="M113.448 134.773C115.105 134.773 116.448 133.43 116.448 131.773C116.448 130.116 115.105 128.772 113.448 128.772C111.791 128.772 110.447 130.116 110.447 131.773C110.447 133.43 111.791 134.773 113.448 134.773Z"
            fill="#2E435F"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_934_16">
          <rect width="288" height="215" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#2E435F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10C12.5523 10 13 10.4477 13 11V16.0009C13 16.5532 12.5523 17.0009 12 17.0009C11.4477 17.0009 11 16.5532 11 16.0009V11C11 10.4477 11.4477 10 12 10Z"
        fill="#2E435F"
      />
      <circle cx="12" cy="8" r="1" fill="#2E435F" />
    </svg>
  );
};

export const BlueLogo = ({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width ? width : 122}
      height={height ? height : 33}
      viewBox="0 0 122 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M73.0077 24.9029V0.5H77.3454V24.9029H73.0077ZM87.8116 25.3096C86.1849 25.3096 84.7157 24.9368 83.4052 24.1912C82.1173 23.4456 81.0893 22.4175 80.321 21.1069C79.5754 19.7738 79.2029 18.2373 79.2029 16.4975C79.2029 14.7577 79.587 13.2325 80.3553 11.9219C81.1229 10.5889 82.1517 9.54945 83.4395 8.80376C84.7494 8.05814 86.2186 7.68532 87.8452 7.68532C89.4499 7.68532 90.8958 8.05814 92.1836 8.80376C93.4941 9.54945 94.5222 10.5889 95.2678 11.9219C96.0361 13.2325 96.4202 14.7577 96.4202 16.4975C96.4202 18.2373 96.0361 19.7738 95.2678 21.1069C94.5222 22.4175 93.4941 23.4456 92.1836 24.1912C90.8731 24.9368 89.4155 25.3096 87.8116 25.3096ZM87.8116 21.5476C88.9413 21.5476 89.924 21.1295 90.7604 20.2935C91.596 19.4349 92.0145 18.1695 92.0145 16.4975C92.0145 14.8254 91.596 13.5714 90.7604 12.7354C89.924 11.8768 88.9523 11.4475 87.8452 11.4475C86.6928 11.4475 85.6984 11.8768 84.8627 12.7354C84.0498 13.5714 83.6429 14.8254 83.6429 16.4975C83.6429 18.1695 84.0498 19.4349 84.8627 20.2935C85.6984 21.1295 86.6811 21.5476 87.8116 21.5476Z"
        fill="#2E435F"
      />
      <path
        d="M0.0638428 24.9033V1.17822H8.8421C10.7401 1.17822 12.3105 1.49454 13.5533 2.12726C14.796 2.7599 15.7224 3.62977 16.3325 4.73701C16.9425 5.84417 17.2476 7.08692 17.2476 8.46525C17.2476 9.77576 16.9539 10.9846 16.3664 12.0918C15.7789 13.1763 14.8638 14.0576 13.621 14.7354C12.3783 15.3907 10.7853 15.7183 8.8421 15.7183H4.40214V24.9033H0.0638428ZM4.40214 12.1934H8.571C10.0849 12.1934 11.1695 11.8658 11.8247 11.2106C12.5026 10.5327 12.8415 9.61757 12.8415 8.46525C12.8415 7.29026 12.5026 6.37511 11.8247 5.71992C11.1695 5.04206 10.0849 4.70313 8.571 4.70313H4.40214V12.1934ZM24.2693 25.3101C22.8232 25.3101 21.6369 25.084 20.7105 24.6322C19.7841 24.1577 19.0949 23.5363 18.643 22.7681C18.1911 21.9998 17.9652 21.1525 17.9652 20.2261C17.9652 18.667 18.5753 17.4017 19.7954 16.4301C21.0155 15.4584 22.8458 14.9726 25.2861 14.9726H29.5566V14.566C29.5566 13.4136 29.2289 12.5662 28.5737 12.024C27.9184 11.4817 27.105 11.2106 26.1334 11.2106C25.2522 11.2106 24.4839 11.4252 23.8286 11.8545C23.1734 12.2613 22.7666 12.8713 22.6085 13.6847H18.3719C18.4848 12.4646 18.8916 11.4027 19.5921 10.4988C20.3151 9.59496 21.2415 8.90582 22.3713 8.43131C23.501 7.93425 24.7663 7.68568 26.1673 7.68568C28.5623 7.68568 30.4491 8.28445 31.8274 9.48205C33.2057 10.6796 33.8949 12.3742 33.8949 14.566V24.9033H30.2006L29.7938 22.1918C29.2967 23.0957 28.5962 23.8414 27.6925 24.4289C26.8113 25.0163 25.6701 25.3101 24.2693 25.3101ZM25.2522 21.9207C26.4949 21.9207 27.4552 21.5141 28.1331 20.7006C28.8335 19.8872 29.2741 18.8816 29.4549 17.6841H25.7606C24.6082 17.6841 23.7834 17.8988 23.2864 18.3281C22.7892 18.7348 22.5407 19.2432 22.5407 19.8533C22.5407 20.5085 22.7892 21.0169 23.2864 21.3785C23.7834 21.74 24.4387 21.9207 25.2522 21.9207Z"
        fill="#2E435F"
      />
      <path
        d="M56.1627 24.9033V1.17822H71.4824V4.66918H60.501V11.3122H69.3809V14.7354H60.501V24.9033H56.1627Z"
        fill="#2E435F"
      />
      <path
        d="M96.2242 7.95654L101.191 25.1952H105.574L109.197 12.6314L112.703 25.1952H116.852L115.041 20.5203L111.418 7.95654H106.743L103.353 20.2281L100.315 7.95654H96.2242Z"
        fill="#2E435F"
      />
      <path
        d="M121.936 7.95654H118.138L115.04 20.5203H118.729L121.936 7.95654Z"
        fill="#00C2FF"
      />
      <path
        d="M35.1581 7.95654H39.833L44.5078 19.936L46.8453 24.6109L43.3391 32.4998H38.6642L41.8782 24.6109L41.586 23.7343L35.1581 7.95654Z"
        fill="#2E435F"
      />
      <path
        d="M48.891 19.936L54.1503 7.95654H49.4753L44.5082 19.936H48.891Z"
        fill="#00C2FF"
      />
    </svg>
  );
};

export const WhiteLogo = () => {
  return (
    <svg
      width="98"
      height="32"
      viewBox="0 0 98 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.1915 24.9432V6.00439H61.546V24.9432H58.1915ZM69.6397 25.2588C68.3818 25.2588 67.2456 24.9695 66.2322 24.3908C65.2362 23.8121 64.4412 23.0143 63.8471 21.9971C63.2705 20.9625 62.9824 19.77 62.9824 18.4198C62.9824 17.0696 63.2795 15.8859 63.8736 14.8688C64.4673 13.8342 65.2628 13.0275 66.2587 12.4488C67.2716 11.8702 68.4079 11.5808 69.6658 11.5808C70.9067 11.5808 72.0248 11.8702 73.0207 12.4488C74.0342 13.0275 74.8292 13.8342 75.4058 14.8688C76 15.8859 76.297 17.0696 76.297 18.4198C76.297 19.77 76 20.9625 75.4058 21.9971C74.8292 23.0143 74.0342 23.8121 73.0207 24.3908C72.0073 24.9695 70.8801 25.2588 69.6397 25.2588ZM69.6397 22.3391C70.5134 22.3391 71.2734 22.0147 71.9201 21.3658C72.5663 20.6995 72.89 19.7175 72.89 18.4198C72.89 17.1222 72.5663 16.1489 71.9201 15.5001C71.2734 14.8337 70.5219 14.5006 69.6658 14.5006C68.7745 14.5006 68.0056 14.8337 67.3593 15.5001C66.7306 16.1489 66.416 17.1222 66.416 18.4198C66.416 19.7175 66.7306 20.6995 67.3593 21.3658C68.0056 22.0147 68.7655 22.3391 69.6397 22.3391Z"
        fill="white"
      />
      <path
        d="M1.78223 24.9434V6.53074H8.57068C10.0384 6.53074 11.2528 6.77623 12.2139 7.26727C13.175 7.75825 13.8914 8.43335 14.3632 9.29266C14.8349 10.1519 15.0708 11.1164 15.0708 12.1861C15.0708 13.2032 14.8437 14.1413 14.3894 15.0006C13.9351 15.8423 13.2274 16.5262 12.2663 17.0523C11.3053 17.5608 10.0734 17.8151 8.57068 17.8151H5.13714V24.9434H1.78223ZM5.13714 15.0795H8.36102C9.53172 15.0795 10.3705 14.8252 10.8772 14.3167C11.4014 13.7906 11.6635 13.0804 11.6635 12.1861C11.6635 11.2742 11.4014 10.564 10.8772 10.0555C10.3705 9.5294 9.53172 9.26636 8.36102 9.26636H5.13714V15.0795ZM20.5009 25.2591C19.3826 25.2591 18.4652 25.0837 17.7488 24.733C17.0324 24.3648 16.4994 23.8825 16.15 23.2863C15.8005 22.69 15.6258 22.0325 15.6258 21.3135C15.6258 20.1035 16.0976 19.1216 17.0411 18.3675C17.9847 17.6134 19.4001 17.2364 21.2872 17.2364H24.5897V16.9208C24.5897 16.0264 24.3363 15.3688 23.8296 14.948C23.3228 14.5271 22.6938 14.3167 21.9425 14.3167C21.261 14.3167 20.6669 14.4833 20.1601 14.8164C19.6534 15.1321 19.3388 15.6056 19.2166 16.2369H15.9403C16.0276 15.2899 16.3422 14.4658 16.8839 13.7643C17.443 13.0628 18.1594 12.528 19.0331 12.1597C19.9068 11.774 20.8853 11.5811 21.9687 11.5811C23.8208 11.5811 25.2799 12.0458 26.3458 12.9752C27.4116 13.9046 27.9446 15.2197 27.9446 16.9208V24.9434H25.0877L24.7732 22.8391C24.3887 23.5406 23.847 24.1193 23.1481 24.5752C22.4667 25.0311 21.5842 25.2591 20.5009 25.2591ZM21.261 22.6287C22.222 22.6287 22.9647 22.3131 23.4889 21.6818C24.0305 21.0505 24.3712 20.2701 24.5111 19.3407H21.6542C20.763 19.3407 20.1252 19.5073 19.7408 19.8405C19.3563 20.1561 19.1642 20.5507 19.1642 21.0242C19.1642 21.5327 19.3563 21.9273 19.7408 22.2079C20.1252 22.4884 20.6319 22.6287 21.261 22.6287Z"
        fill="white"
      />
      <path
        d="M45.1649 24.9434V6.53074H57.0121V9.24002H48.5199V14.3956H55.3869V17.0523H48.5199V24.9434H45.1649Z"
        fill="white"
      />
      <path
        d="M76.1454 11.7914L79.9867 25.1701H83.3762L86.1779 15.4195L88.8893 25.1701H92.0976L90.6967 21.542L87.895 11.7914H84.2796L81.6586 21.3152L79.3091 11.7914H76.1454Z"
        fill="white"
      />
      <path
        d="M96.0291 11.7914H93.0918L90.6961 21.542H93.5489L96.0291 11.7914Z"
        fill="#00C2FF"
      />
      <path
        d="M28.9215 11.7914H32.5367L36.1519 21.0884L37.9595 24.7166L35.2481 30.839H31.6329L34.1184 24.7166L33.8924 24.0363L28.9215 11.7914Z"
        fill="white"
      />
      <path
        d="M39.5416 21.0885L43.6087 11.7914H39.9935L36.1523 21.0885H39.5416Z"
        fill="#00C2FF"
      />
    </svg>
  );
};

export const QuestionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4917 14.1497V14.0205C10.495 13.4206 10.5513 12.9433 10.6607 12.5887C10.7734 12.234 10.9325 11.949 11.138 11.7336C11.3435 11.5148 11.5937 11.3143 11.8887 11.132C12.0908 11.006 12.2715 10.8685 12.4306 10.7194C12.593 10.5669 12.7206 10.3979 12.8134 10.2122C12.9062 10.0233 12.9526 9.81287 12.9526 9.58086C12.9526 9.31902 12.8913 9.09198 12.7686 8.89975C12.646 8.70752 12.4803 8.55837 12.2715 8.45231C12.066 8.34625 11.8356 8.29322 11.5804 8.29322C11.3451 8.29322 11.1214 8.34459 10.9093 8.44734C10.7005 8.54677 10.5265 8.69923 10.3873 8.90472C10.2514 9.1069 10.1751 9.36377 10.1586 9.67532H8.38867C8.40524 9.04558 8.55771 8.51859 8.84606 8.09435C9.13772 7.67011 9.52219 7.35193 9.99947 7.13981C10.4801 6.92769 11.0104 6.82162 11.5904 6.82162C12.2234 6.82162 12.7802 6.93266 13.2608 7.15472C13.7447 7.37679 14.1209 7.69331 14.3894 8.10429C14.6612 8.51197 14.7971 8.99587 14.7971 9.556C14.7971 9.93384 14.7357 10.2719 14.6131 10.5702C14.4938 10.8685 14.3231 11.1337 14.101 11.3657C13.879 11.5977 13.6155 11.8048 13.3105 11.9871C13.0421 12.1528 12.8217 12.3252 12.6493 12.5042C12.4803 12.6831 12.3543 12.8936 12.2715 13.1355C12.1919 13.3742 12.1505 13.6692 12.1472 14.0205V14.1497H10.4917ZM11.3567 17.252C11.0584 17.252 10.8016 17.146 10.5861 16.9338C10.3707 16.7217 10.263 16.4632 10.263 16.1583C10.263 15.86 10.3707 15.6048 10.5861 15.3926C10.8016 15.1805 11.0584 15.0745 11.3567 15.0745C11.6517 15.0745 11.9069 15.1805 12.1223 15.3926C12.3411 15.6048 12.4505 15.86 12.4505 16.1583C12.4505 16.3605 12.3991 16.5444 12.2963 16.7101C12.1969 16.8758 12.0643 17.0084 11.8986 17.1078C11.7362 17.204 11.5556 17.252 11.3567 17.252Z"
        fill="white"
      />
    </svg>
  );
};

export const SelectedHomeIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.3335 20C1.67664 20 0.333496 18.6569 0.333496 17V9.33609C0.333496 8.48563 0.69446 7.67513 1.3266 7.1062L8.3266 0.806205C9.46751 -0.220618 11.1995 -0.220619 12.3404 0.806204L19.3404 7.1062C19.9725 7.67513 20.3335 8.48563 20.3335 9.33609V17C20.3335 18.6569 18.9904 20 17.3335 20H3.3335ZM18.3335 9.33609V17C18.3335 17.5523 17.8858 18 17.3335 18H14.3335V13C14.3335 11.3431 12.9904 10 11.3335 10H9.3335C7.67664 10 6.3335 11.3431 6.3335 13V18H3.3335C2.78121 18 2.3335 17.5523 2.3335 17V9.33609C2.3335 9.0526 2.45382 8.78243 2.66453 8.59279L9.66453 2.29279C10.0448 1.95052 10.6222 1.95052 11.0025 2.29279L18.0025 8.59279C18.2132 8.78243 18.3335 9.0526 18.3335 9.33609ZM8.3335 18V13C8.3335 12.4477 8.78121 12 9.3335 12H11.3335C11.8858 12 12.3335 12.4477 12.3335 13V18H8.3335Z"
        fill="white"
      />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2458 0.987525C10.098 0.184112 8.5704 0.184109 7.42267 0.987524L1.69135 4.99944C0.725837 5.6753 0.188985 6.81078 0.279377 7.98587L0.866892 15.6236C0.977698 17.064 2.28287 18.111 3.71308 17.9067L6.35443 17.5294C7.58605 17.3534 8.50087 16.2986 8.50087 15.0545V14C8.50087 13.5398 8.87397 13.1667 9.33421 13.1667C9.79444 13.1667 10.1675 13.5398 10.1675 14V15.0545C10.1675 16.2986 11.0824 17.3534 12.314 17.5294L14.9553 17.9067C16.3855 18.111 17.6907 17.064 17.8015 15.6236L18.389 7.98587C18.4794 6.81078 17.9426 5.67531 16.9771 4.99944L11.2458 0.987525ZM8.37844 2.35291C8.9523 1.9512 9.71611 1.9512 10.29 2.35291L16.0213 6.36483C16.5041 6.70276 16.7725 7.2705 16.7273 7.85805L16.1398 15.4957C16.1028 15.9759 15.6678 16.3249 15.191 16.2568L12.5497 15.8795C12.1391 15.8208 11.8342 15.4692 11.8342 15.0545V14C11.8342 12.6193 10.7149 11.5 9.33421 11.5C7.9535 11.5 6.83421 12.6193 6.83421 14V15.0545C6.83421 15.4692 6.52927 15.8208 6.11873 15.8795L3.47738 16.2568C3.00064 16.3249 2.56558 15.9759 2.52865 15.4957L1.94113 7.85804C1.89594 7.2705 2.16436 6.70276 2.64712 6.36483L8.37844 2.35291Z"
        fill="white"
      />
    </svg>
  );
};

export const OnboardingLogo = () => {
  return (
    <svg
      width="133"
      height="32"
      viewBox="0 0 133 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M101.21 17.6872V14.2179H100.599V13.6382H101.21V12.9362C101.21 12.5444 101.308 12.2587 101.503 12.0791C101.698 11.8995 101.984 11.8097 102.358 11.8097H102.766V12.3974H102.464C102.258 12.3974 102.111 12.4409 102.025 12.528C101.937 12.6097 101.894 12.7512 101.894 12.9525V13.6382H102.887V14.2179H101.894V17.6872H101.21ZM103.539 17.6872V13.6382H104.158L104.215 14.4137C104.34 14.1471 104.53 13.9349 104.785 13.777C105.04 13.6192 105.355 13.5403 105.729 13.5403V14.2587H105.542C105.303 14.2587 105.084 14.3022 104.882 14.3893C104.682 14.4709 104.522 14.6124 104.402 14.8137C104.283 15.0151 104.223 15.2927 104.223 15.6464V17.6872H103.539ZM108.023 17.7852C107.644 17.7852 107.301 17.6981 106.998 17.524C106.693 17.3498 106.452 17.1049 106.273 16.7893C106.099 16.4682 106.012 16.0927 106.012 15.6628C106.012 15.2328 106.102 14.86 106.281 14.5444C106.46 14.2233 106.701 13.9757 107.006 13.8015C107.315 13.6273 107.659 13.5403 108.04 13.5403C108.42 13.5403 108.762 13.6273 109.066 13.8015C109.37 13.9757 109.609 14.2233 109.782 14.5444C109.961 14.86 110.051 15.2328 110.051 15.6628C110.051 16.0927 109.961 16.4682 109.782 16.7893C109.603 17.1049 109.359 17.3498 109.05 17.524C108.745 17.6981 108.403 17.7852 108.023 17.7852ZM108.023 17.1974C108.257 17.1974 108.474 17.1403 108.675 17.026C108.876 16.9117 109.038 16.7403 109.163 16.5117C109.288 16.2831 109.351 16.0001 109.351 15.6628C109.351 15.3253 109.288 15.0423 109.163 14.8137C109.044 14.5852 108.884 14.4137 108.683 14.2995C108.482 14.1852 108.268 14.128 108.04 14.128C107.806 14.128 107.589 14.1852 107.388 14.2995C107.188 14.4137 107.025 14.5852 106.9 14.8137C106.775 15.0423 106.713 15.3253 106.713 15.6628C106.713 16.0001 106.775 16.2831 106.9 16.5117C107.025 16.7403 107.185 16.9117 107.38 17.026C107.581 17.1403 107.796 17.1974 108.023 17.1974ZM110.839 17.6872V13.6382H111.458L111.507 14.226C111.637 14.0083 111.811 13.8396 112.028 13.7199C112.245 13.6001 112.49 13.5403 112.761 13.5403C113.082 13.5403 113.356 13.6056 113.584 13.7362C113.817 13.8668 113.996 14.0655 114.121 14.3321C114.262 14.0872 114.455 13.894 114.699 13.7525C114.949 13.611 115.218 13.5403 115.505 13.5403C115.988 13.5403 116.374 13.6872 116.661 13.9811C116.949 14.2695 117.093 14.7158 117.093 15.3199V17.6872H116.417V15.3934C116.417 14.9743 116.333 14.6587 116.165 14.4464C115.996 14.2342 115.755 14.128 115.44 14.128C115.114 14.128 114.843 14.2559 114.626 14.5117C114.414 14.7621 114.308 15.1213 114.308 15.5893V17.6872H113.624V15.3934C113.624 14.9743 113.54 14.6587 113.372 14.4464C113.203 14.2342 112.962 14.128 112.647 14.128C112.327 14.128 112.058 14.2559 111.841 14.5117C111.629 14.7621 111.523 15.1213 111.523 15.5893V17.6872H110.839ZM119.953 17.6872V11.8097H120.637V14.3321C120.772 14.0818 120.965 13.8886 121.215 13.7525C121.464 13.611 121.736 13.5403 122.029 13.5403C122.496 13.5403 122.87 13.6872 123.153 13.9811C123.435 14.2695 123.576 14.7158 123.576 15.3199V17.6872H122.9V15.3934C122.9 14.5498 122.561 14.128 121.882 14.128C121.53 14.128 121.234 14.2559 120.995 14.5117C120.756 14.7621 120.637 15.1213 120.637 15.5893V17.6872H119.953ZM124.865 12.7403C124.729 12.7403 124.615 12.6967 124.523 12.6097C124.436 12.5172 124.393 12.4029 124.393 12.2668C124.393 12.1362 124.436 12.0273 124.523 11.9403C124.615 11.8532 124.729 11.8097 124.865 11.8097C124.995 11.8097 125.106 11.8532 125.199 11.9403C125.291 12.0273 125.337 12.1362 125.337 12.2668C125.337 12.4029 125.291 12.5172 125.199 12.6097C125.106 12.6967 124.995 12.7403 124.865 12.7403ZM124.523 17.6872V13.6382H125.207V17.6872H124.523ZM126.235 17.6872V13.6382H126.854L126.911 14.4137C127.035 14.1471 127.225 13.9349 127.481 13.777C127.736 13.6192 128.051 13.5403 128.426 13.5403V14.2587H128.238C127.999 14.2587 127.779 14.3022 127.579 14.3893C127.378 14.4709 127.217 14.6124 127.098 14.8137C126.979 15.0151 126.919 15.2927 126.919 15.6464V17.6872H126.235ZM130.695 17.7852C130.309 17.7852 129.967 17.6981 129.669 17.524C129.37 17.3444 129.134 17.0967 128.961 16.7811C128.792 16.4655 128.708 16.0927 128.708 15.6628C128.708 15.2382 128.792 14.8682 128.961 14.5525C129.129 14.2315 129.362 13.9838 129.661 13.8097C129.965 13.6301 130.315 13.5403 130.711 13.5403C131.102 13.5403 131.439 13.6301 131.721 13.8097C132.009 13.9838 132.228 14.2151 132.38 14.5036C132.533 14.792 132.609 15.1022 132.609 15.4342C132.609 15.494 132.606 15.5539 132.6 15.6137C132.6 15.6736 132.6 15.7416 132.6 15.8179H129.384C129.4 16.128 129.471 16.3865 129.595 16.5934C129.726 16.7947 129.886 16.9471 130.076 17.0505C130.272 17.1539 130.478 17.2056 130.695 17.2056C130.977 17.2056 131.213 17.1403 131.403 17.0097C131.594 16.8791 131.732 16.7022 131.819 16.4791H132.494C132.386 16.8545 132.177 17.1675 131.868 17.4179C131.563 17.6628 131.173 17.7852 130.695 17.7852ZM130.695 14.1199C130.369 14.1199 130.079 14.2206 129.824 14.4219C129.574 14.6179 129.43 14.9063 129.392 15.2872H131.933C131.917 14.9226 131.792 14.6369 131.558 14.4301C131.324 14.2233 131.037 14.1199 130.695 14.1199ZM102.586 24.9435C102.217 24.9435 101.927 24.8536 101.715 24.6741C101.503 24.4945 101.397 24.1707 101.397 23.7027V21.4741H100.697V20.8945H101.397L101.487 19.9231H102.081V20.8945H103.27V21.4741H102.081V23.7027C102.081 23.9584 102.133 24.1326 102.236 24.2251C102.339 24.3121 102.521 24.3557 102.782 24.3557H103.205V24.9435H102.586ZM105.705 25.0414C105.326 25.0414 104.984 24.9543 104.679 24.7802C104.375 24.6061 104.134 24.3612 103.955 24.0455C103.781 23.7244 103.694 23.3489 103.694 22.919C103.694 22.4891 103.784 22.1163 103.963 21.8006C104.142 21.4795 104.383 21.2319 104.688 21.0577C104.997 20.8836 105.342 20.7965 105.722 20.7965C106.102 20.7965 106.444 20.8836 106.748 21.0577C107.052 21.2319 107.291 21.4795 107.464 21.8006C107.644 22.1163 107.733 22.4891 107.733 22.919C107.733 23.3489 107.644 23.7244 107.464 24.0455C107.285 24.3612 107.041 24.6061 106.732 24.7802C106.427 24.9543 106.085 25.0414 105.705 25.0414ZM105.705 24.4536C105.939 24.4536 106.156 24.3965 106.357 24.2822C106.558 24.1679 106.72 23.9965 106.846 23.7679C106.971 23.5394 107.033 23.2564 107.033 22.919C107.033 22.5815 106.971 22.2985 106.846 22.07C106.726 21.8414 106.566 21.67 106.365 21.5557C106.164 21.4414 105.95 21.3843 105.722 21.3843C105.488 21.3843 105.271 21.4414 105.07 21.5557C104.87 21.67 104.706 21.8414 104.582 22.07C104.457 22.2985 104.395 22.5815 104.395 22.919C104.395 23.2564 104.457 23.5394 104.582 23.7679C104.706 23.9965 104.866 24.1679 105.062 24.2822C105.263 24.3965 105.477 24.4536 105.705 24.4536ZM110.513 26.7394V20.8945H111.132L111.197 21.5639C111.328 21.3679 111.512 21.1911 111.751 21.0333C111.995 20.8755 112.305 20.7965 112.679 20.7965C113.081 20.7965 113.431 20.8891 113.73 21.0741C114.029 21.2591 114.259 21.5121 114.422 21.8333C114.59 22.1543 114.674 22.519 114.674 22.9271C114.674 23.3353 114.59 23.6999 114.422 24.021C114.259 24.3367 114.025 24.587 113.722 24.772C113.423 24.9516 113.073 25.0414 112.671 25.0414C112.34 25.0414 112.044 24.9734 111.784 24.8373C111.529 24.7013 111.333 24.5108 111.197 24.2659V26.7394H110.513ZM112.598 24.4455C112.869 24.4455 113.108 24.3829 113.315 24.2577C113.521 24.1271 113.684 23.9476 113.803 23.719C113.923 23.4904 113.982 23.2237 113.982 22.919C113.982 22.6142 113.923 22.3476 113.803 22.119C113.684 21.8904 113.521 21.7135 113.315 21.5884C113.108 21.4577 112.869 21.3925 112.598 21.3925C112.327 21.3925 112.088 21.4577 111.881 21.5884C111.675 21.7135 111.512 21.8904 111.393 22.119C111.273 22.3476 111.214 22.6142 111.214 22.919C111.214 23.2237 111.273 23.4904 111.393 23.719C111.512 23.9476 111.675 24.1271 111.881 24.2577C112.088 24.3829 112.327 24.4455 112.598 24.4455ZM116.807 25.0414C116.47 25.0414 116.191 24.9843 115.969 24.87C115.746 24.7557 115.58 24.6033 115.472 24.4128C115.363 24.2224 115.309 24.0156 115.309 23.7925C115.309 23.3788 115.467 23.0605 115.782 22.8373C116.096 22.6142 116.525 22.5027 117.068 22.5027H118.159V22.4536C118.159 22.0999 118.066 21.8333 117.882 21.6536C117.698 21.4686 117.45 21.3761 117.141 21.3761C116.875 21.3761 116.644 21.4441 116.449 21.5802C116.259 21.7108 116.14 21.904 116.091 22.1598H115.39C115.418 21.8659 115.516 21.6183 115.684 21.4169C115.857 21.2156 116.072 21.0632 116.327 20.9598C116.582 20.8509 116.853 20.7965 117.141 20.7965C117.706 20.7965 118.129 20.9489 118.411 21.2536C118.699 21.553 118.843 21.953 118.843 22.4536V24.9435H118.232L118.191 24.2169C118.078 24.4455 117.91 24.6414 117.687 24.8047C117.47 24.9625 117.176 25.0414 116.807 25.0414ZM116.913 24.4619C117.174 24.4619 117.396 24.3938 117.581 24.2577C117.771 24.1217 117.915 23.9448 118.012 23.7271C118.11 23.5094 118.159 23.2809 118.159 23.0414V23.0333H117.125C116.723 23.0333 116.438 23.104 116.27 23.2455C116.107 23.3815 116.026 23.553 116.026 23.7598C116.026 23.972 116.102 24.1435 116.253 24.2741C116.411 24.3992 116.631 24.4619 116.913 24.4619ZM120.026 26.7394L121.028 24.5516H120.792L119.188 20.8945H119.928L121.264 24.0455L122.681 20.8945H123.39L120.743 26.7394H120.026Z"
        fill="white"
      />
      <path
        d="M58.2532 24.9432V6.00439H61.6112V24.9432H58.2532ZM69.7136 25.2588C68.4543 25.2588 67.3169 24.9695 66.3024 24.3908C65.3054 23.8121 64.5096 23.0143 63.9148 21.9971C63.3376 20.9625 63.0492 19.77 63.0492 18.4198C63.0492 17.0696 63.3466 15.8859 63.9414 14.8688C64.5356 13.8342 65.332 13.0275 66.329 12.4488C67.343 11.8702 68.4804 11.5808 69.7396 11.5808C70.9819 11.5808 72.1012 11.8702 73.0982 12.4488C74.1127 13.0275 74.9086 13.8342 75.4858 14.8688C76.0806 15.8859 76.3779 17.0696 76.3779 18.4198C76.3779 19.77 76.0806 20.9625 75.4858 21.9971C74.9086 23.0143 74.1127 23.8121 73.0982 24.3908C72.0836 24.9695 70.9553 25.2588 69.7136 25.2588ZM69.7136 22.3391C70.5882 22.3391 71.3489 22.0147 71.9964 21.3658C72.6433 20.6995 72.9673 19.7175 72.9673 18.4198C72.9673 17.1222 72.6433 16.1489 71.9964 15.5001C71.3489 14.8337 70.5967 14.5006 69.7396 14.5006C68.8475 14.5006 68.0777 14.8337 67.4308 15.5001C66.8014 16.1489 66.4865 17.1222 66.4865 18.4198C66.4865 19.7175 66.8014 20.6995 67.4308 21.3658C68.0777 22.0147 68.8384 22.3391 69.7136 22.3391Z"
        fill="white"
      />
      <path
        d="M1.78412 24.9434V6.53073H8.57977C10.0491 6.53073 11.2648 6.77622 12.2269 7.26726C13.189 7.75825 13.9061 8.43334 14.3784 9.29265C14.8507 10.1519 15.0868 11.1164 15.0868 12.1861C15.0868 13.2032 14.8594 14.1413 14.4046 15.0006C13.9499 15.8423 13.2414 16.5262 12.2794 17.0523C11.3173 17.5608 10.0841 17.8151 8.57977 17.8151H5.14259V24.9434H1.78412ZM5.14259 15.0795H8.3699C9.54184 15.0795 10.3815 14.8252 10.8888 14.3167C11.4135 13.7906 11.6759 13.0804 11.6759 12.1861C11.6759 11.2742 11.4135 10.564 10.8888 10.0555C10.3815 9.5294 9.54184 9.26636 8.3699 9.26636H5.14259V15.0795ZM20.5226 25.2591C19.4032 25.2591 18.4848 25.0837 17.7676 24.733C17.0504 24.3648 16.5169 23.8825 16.1671 23.2863C15.8173 22.69 15.6423 22.0325 15.6423 21.3135C15.6423 20.1035 16.1146 19.1216 17.0592 18.3675C18.0038 17.6134 19.4207 17.2364 21.3098 17.2364H24.6158V16.9208C24.6158 16.0264 24.3621 15.3688 23.8549 14.948C23.3476 14.5271 22.7179 14.3167 21.9657 14.3167C21.2836 14.3167 20.6888 14.4833 20.1815 14.8164C19.6743 15.1321 19.3594 15.6056 19.237 16.2369H15.9572C16.0446 15.2899 16.3595 14.4658 16.9018 13.7643C17.4615 13.0628 18.1787 12.528 19.0533 12.1597C19.9279 11.774 20.9074 11.5811 21.992 11.5811C23.8461 11.5811 25.3067 12.0458 26.3737 12.9752C27.4407 13.9046 27.9743 15.2197 27.9743 16.9208V24.9434H25.1143L24.7994 22.8391C24.4146 23.5406 23.8723 24.1193 23.1727 24.5752C22.4905 25.0311 21.6071 25.2591 20.5226 25.2591ZM21.2836 22.6287C22.2456 22.6287 22.989 22.3131 23.5138 21.6818C24.056 21.0505 24.3971 20.2701 24.5371 19.3407H21.6771C20.785 19.3407 20.1465 19.5073 19.7617 19.8405C19.3769 20.1561 19.1845 20.5507 19.1845 21.0242C19.1845 21.5327 19.3769 21.9273 19.7617 22.2079C20.1465 22.4884 20.6538 22.6287 21.2836 22.6287Z"
        fill="white"
      />
      <path
        d="M45.2128 24.9434V6.53073H57.0725V9.24001H48.5713V14.3956H55.4456V17.0523H48.5713V24.9434H45.2128Z"
        fill="white"
      />
      <path
        d="M76.2262 11.7914L80.0715 25.1701H83.4646L86.2693 15.4195L88.9836 25.1701H92.1952L90.7929 21.542L87.9882 11.7914H84.369L81.7452 21.3152L79.3932 11.7914H76.2262Z"
        fill="white"
      />
      <path
        d="M96.1309 11.7914H93.1906L90.7923 21.542H93.6481L96.1309 11.7914Z"
        fill="#00C2FF"
      />
      <path
        d="M28.9522 11.7914H32.5712L36.1903 21.0884L37.9998 24.7166L35.2855 30.839H31.6665L34.1546 24.7166L33.9284 24.0363L28.9522 11.7914Z"
        fill="white"
      />
      <path
        d="M39.5835 21.0885L43.6549 11.7914H40.0359L36.1906 21.0885H39.5835Z"
        fill="#00C2FF"
      />
    </svg>
  );
};
export const isCheckedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C14.3582 4 16.478 5.02032 17.9422 6.64358L11 13.5858L8.20711 10.7929C7.81658 10.4024 7.18342 10.4024 6.79289 10.7929C6.40237 11.1834 6.40237 11.8166 6.79289 12.2071L9.58579 15C10.3668 15.7811 11.6332 15.781 12.4142 15L19.1015 8.31276C19.6755 9.41616 20 10.6702 20 12Z"
        fill="#828E9F"
      />
    </svg>
  );
};

export const notCheckedIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9" stroke="#828E9F" strokeWidth="2" />
    </svg>
  );
};

export const CloseHamburgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

export const HamburgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
};

export const DownArrow = () => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.25696L7 7.25696L13 1.25696"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = ({ color }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
        stroke={color ? color : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0004 18.9999L14.6504 14.6499"
        stroke={color ? color : 'black'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z"
        fill="#828E9F"
      />
    </svg>
  );
};

export const EyeOffIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92305 8.24268C8.0814 8.64504 7.5 9.50435 7.5 10.4995C7.5 11.8802 8.61929 12.9995 10 12.9995C10.9951 12.9995 11.8544 12.4181 12.2568 11.5764L8.92305 8.24268ZM10.8333 10.4995C10.8333 10.9597 10.4602 11.3328 10 11.3328C9.53976 11.3328 9.16667 10.9597 9.16667 10.4995C9.16667 10.0392 9.53976 9.66613 10 9.66613C10.4602 9.66613 10.8333 10.0392 10.8333 10.4995Z"
        fill="#828E9F"
      />
      <path
        d="M6.2508 5.57032C4.15451 6.65236 2.82755 8.45536 2.16815 9.55488C1.81626 10.1416 1.81626 10.857 2.16815 11.4438C3.15839 13.095 5.65414 16.3327 9.99999 16.3327C12.1772 16.3327 13.8901 15.5201 15.1819 14.5014L13.9932 13.3127C12.9565 14.0854 11.6332 14.666 9.99999 14.666C6.57328 14.666 4.51118 12.1102 3.59749 10.5866C3.57662 10.5518 3.5709 10.5225 3.5709 10.4993C3.5709 10.4762 3.57662 10.4469 3.59749 10.4121C4.26313 9.30214 5.53826 7.64434 7.50649 6.82601L6.2508 5.57032Z"
        fill="#828E9F"
      />
      <path
        d="M15.2231 12.1856C15.7297 11.6246 16.1207 11.0565 16.4025 10.5866C16.4234 10.5518 16.4291 10.5225 16.4291 10.4993C16.4291 10.4762 16.4234 10.4469 16.4025 10.4121C15.4888 8.88851 13.4267 6.33268 9.99999 6.33268C9.79411 6.33268 9.59316 6.34191 9.39708 6.35958L7.9568 4.9193C8.58631 4.75817 9.26682 4.66602 9.99999 4.66602C14.3458 4.66602 16.8416 7.90369 17.8318 9.55488C18.1837 10.1416 18.1837 10.8571 17.8318 11.4438C17.514 11.9737 17.0412 12.6671 16.4018 13.3643L15.2231 12.1856Z"
        fill="#828E9F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.91076 2.41009C2.2362 2.08466 2.76384 2.08466 3.08928 2.41009L18.0893 17.4101C18.4147 17.7355 18.4147 18.2632 18.0893 18.5886C17.7638 18.914 17.2362 18.914 16.9108 18.5886L1.91076 3.5886C1.58533 3.26317 1.58533 2.73553 1.91076 2.41009Z"
        fill="#828E9F"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99999 14.1667C13.4267 14.1667 15.4888 11.6109 16.4025 10.0873C16.4234 10.0525 16.4291 10.0232 16.4291 10C16.4291 9.97687 16.4234 9.94755 16.4025 9.91274C15.4888 8.38919 13.4267 5.83335 9.99999 5.83335C6.57329 5.83335 4.51118 8.38918 3.59749 9.91274C3.57662 9.94755 3.5709 9.97687 3.5709 10C3.5709 10.0232 3.57662 10.0525 3.59749 10.0873C4.51118 11.6109 6.57328 14.1667 9.99999 14.1667ZM17.8318 10.9445C16.8416 12.5957 14.3458 15.8334 9.99999 15.8334C5.65414 15.8334 3.15839 12.5957 2.16815 10.9445C1.81626 10.3577 1.81626 9.64232 2.16815 9.05555C3.15839 7.40436 5.65414 4.16669 9.99999 4.16669C14.3458 4.16669 16.8416 7.40436 17.8318 9.05555C18.1837 9.64232 18.1837 10.3577 17.8318 10.9445Z"
        fill="#58697F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 10C10.8333 9.53976 10.4602 9.16667 10 9.16667C9.53976 9.16667 9.16667 9.53976 9.16667 10C9.16667 10.4602 9.53976 10.8333 10 10.8333ZM10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        fill="#58697F"
      />
    </svg>
  );
};

export const ThreeDots = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VerifiedIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6673 7.88674V8.50007C14.6665 9.93769 14.201 11.3365 13.3402 12.488C12.4794 13.6394 11.2695 14.4817 9.89089 14.8893C8.51227 15.297 7.03882 15.248 5.6903 14.7498C4.34177 14.2516 3.19042 13.3308 2.40796 12.1248C1.6255 10.9188 1.25385 9.49212 1.34844 8.05762C1.44303 6.62312 1.99879 5.25762 2.93284 4.16479C3.86689 3.07195 5.12917 2.31033 6.53144 1.9935C7.93371 1.67668 9.40083 1.82163 10.714 2.40674"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 3.1665L8 9.83984L6 7.83984"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 17C18 18.6569 16.6569 20 15 20H3C1.34315 20 0 18.6569 0 17V3C0 1.34315 1.34315 0 3 0H13L13.0107 0.01071C13.7136 0.07025 14.3761 0.3761 14.8787 0.87868L17.1213 3.12132C17.6239 3.6239 17.9297 4.28645 17.9893 4.98929L18 5V17ZM15 18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44771 2 3 2H12V4C12 5.10457 12.8954 6 14 6H16V17C16 17.5523 15.5523 18 15 18Z"
        fill="#828E9F"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.70711 0.292893C1.31658 -0.097631 0.683418 -0.0976311 0.292893 0.292893C-0.097631 0.683417 -0.0976312 1.31658 0.292893 1.70711L5.5858 7.00002L0.292922 12.2929C-0.0976021 12.6834 -0.0976021 13.3166 0.292922 13.7071C0.683447 14.0976 1.31661 14.0976 1.70714 13.7071L7.00001 8.41423L12.2929 13.7071C12.6834 14.0976 13.3166 14.0976 13.7071 13.7071C14.0976 13.3166 14.0976 12.6834 13.7071 12.2929L8.41423 7.00002L13.7071 1.70711C14.0977 1.31658 14.0977 0.683419 13.7071 0.292895C13.3166 -0.0976298 12.6834 -0.0976294 12.2929 0.292895L7.00001 5.5858L1.70711 0.292893Z"
        fill="white"
      />
    </svg>
  );
};

export const UkFlagIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="ukFlagCircle">
          <circle cx="12" cy="12" r="12" />
        </clipPath>
      </defs>
      <g clipPath="url(#ukFlagCircle)">
        <rect width="24" height="24" fill="#012169" />
        <path d="M0 0L24 24M24 0L0 24" stroke="white" strokeWidth="5" />
        <path d="M0 0L24 24M24 0L0 24" stroke="#C8102E" strokeWidth="2.5" />
        <path d="M12 0V24M0 12H24" stroke="white" strokeWidth="8" />
        <path d="M12 0V24M0 12H24" stroke="#C8102E" strokeWidth="4.5" />
      </g>
    </svg>
  );
};

export const GermanFlagIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="germanFlagCircle">
          <circle cx="12" cy="12" r="12" />
        </clipPath>
      </defs>
      <g clipPath="url(#germanFlagCircle)">
        <rect width="24" height="8" fill="#000000" />
        <rect y="8" width="24" height="8" fill="#DD0000" />
        <rect y="16" width="24" height="8" fill="#FFCE00" />
      </g>
    </svg>
  );
};
